import axiosInstance from '../../../utils/apiConfig';

const clinicsApi = {
  // Get all clinics for a partner
  getByPartner: (partnerId, params) =>
    axiosInstance
      .get(`/b2b/partners/${partnerId}/clinics`, { params })
      .then((res) => res.data),

  // Get single clinic details
  getById: (partnerId, clinicId) =>
    axiosInstance
      .get(`/b2b/partners/${partnerId}/clinics/${clinicId}`)
      .then((res) => res.data),

  // Create new clinic
  create: (partnerId, data) =>
    axiosInstance
      .post(`/b2b/partners/${partnerId}/clinics`, data)
      .then((res) => res.data),

  // Update clinic
  update: (partnerId, clinicId, data) =>
    axiosInstance
      .put(`/b2b/partners/${partnerId}/clinics/${clinicId}`, data)
      .then((res) => res.data),

  // Delete clinic
  delete: (partnerId, clinicId) =>
    axiosInstance
      .delete(`/b2b/partners/${partnerId}/clinics/${clinicId}`)
      .then((res) => res.data),

  // Update clinic status
  updateStatus: (partnerId, clinicId, status) =>
    axiosInstance
      .patch(`/b2b/partners/${partnerId}/clinics/${clinicId}/status`, { status })
      .then((res) => res.data),

  // Update working hours
  updateWorkingHours: (partnerId, clinicId, workingHours) =>
    axiosInstance
      .put(`/b2b/partners/${partnerId}/clinics/${clinicId}/working-hours/bulk-update`, {
        working_hours: workingHours,
      })
      .then((res) => res.data),
};

export default clinicsApi;